import type { ReactNode } from 'react'
import { create } from 'zustand'
import { combine, devtools } from 'zustand/middleware'

export interface ConfirmationProps {
  title: string
  description: ReactNode
  onConfirm: () => void
}

export const useConfirmationStore = create(
  devtools(
    combine(
      {
        isOpen: false,
        title: '',
        description: '' as ReactNode,
        onConfirm: () => {},
      },
      (set) => ({
        open: ({ title, description, onConfirm }: ConfirmationProps) =>
          set({
            isOpen: true,
            title,
            description,
            onConfirm,
          }),
        setIsOpen: (isOpen: boolean) => set({ isOpen }),
      })
    )
  )
)
